import {z} from 'zod';
import {NodeOutputData, NodeType, OutputType} from 'common/src/modules/nodes/nodes.types';
import {DTScheduleNode, ScheduleType} from 'common/src/modules/decisionTree/decisionTree.types';
import {scheduleCardSchema} from '../../../../../schemas/scheduleCardSchema';
import {TimezoneSource} from 'common/src/modules/timezones/timezones.types';
import {NO_NODE_ID} from 'common/src/components/CLCardsMap/CLCardsMap.config';
import {getAICardBaseDetails} from '../../utils/getAICardBaseDetails';
import {DateTime} from 'luxon';
import {UTCAbbreviation} from 'common/src/modules/timezones/timezones.consts';

export function convertScheduleAICardToAPICard(
  scheduleCard: z.input<typeof scheduleCardSchema>,
  existingCard: DTScheduleNode,
): DTScheduleNode {
  const normalizedTimeZone = scheduleCard.timeZone?.trim() || UTCAbbreviation;

  const outputs = scheduleCard.outputs.map(
    (output, index) =>
      ({
        id: index + 1,
        nodeId: existingCard?.outputs?.[index]?.nodeId ?? NO_NODE_ID,
        name: output.name ?? `Output ${index + 1}`,
        type: OutputType.Regular,
        dateRange: output.dateRange
          ? {
              start: DateTime.fromISO(output.dateRange.start, {
                zone: normalizedTimeZone,
              }),
              end: DateTime.fromISO(output.dateRange.end, {
                zone: normalizedTimeZone,
              }),
            }
          : null,
        daysOfWeek: output.daysOfWeek ? output.daysOfWeek : null,
      }) as NodeOutputData,
  );

  if (!outputs.some((output) => (output as NodeOutputData).type === OutputType.Fallback)) {
    outputs.push({
      id: outputs.length + 1,
      name: 'Fallback',
      type: OutputType.Fallback,
      nodeId: 0,
    });
  }

  return {
    ...getAICardBaseDetails(scheduleCard),
    ...scheduleCard,
    type: NodeType.SCHEDULE,
    scheduleType: scheduleCard.scheduleType ?? ScheduleType.DateRange,
    timezoneSource: scheduleCard.timezoneSource ?? TimezoneSource.Advertiser,
    timeZone: normalizedTimeZone,
    randomizeOutputs: scheduleCard.randomizeOutputs ?? false,
    outputs: outputs,
    inputs: [],
  } as DTScheduleNode;
}
